import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab, ButtonToolbar } from 'react-bootstrap';
import { Switch, Route } from 'react-router-dom';
import {
	fetchParent, createParent, updateParent, sendMessage,
	PARENT_SEND_MESSAGE_REQUEST, PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE
} from './actions';
import ParentSettingsForm from './SettingsForm';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';
import BackButton from '../../common/components/BackButton';
import ChildrenList from '../children/index';
import ChildDetails from '../children/Details';
import ParentDocumentsList from '../parentDocuments/index';
import ParentDocumentDetails from '../parentDocuments/Details';
import ParentCommunications from '../reports/sentEmails';
import ParentMakeupSummary from '../parentMakeupSummary';
import PaymentHistory from './PaymentHistory';
import Enrolments from './Enrolments';
import WorkshopPayments from '../workshopPayments/index';
import IndividualConsultations from '../individualConsultations/index';
import IndividualConsultationForms from './Forms';
import SelfAssessments from './SelfAssessments';
import SendMessageButton from '../../common/components/message/SendMessageButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightToBracket } from '@fortawesome/free-solid-svg-icons';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleParentSettingsSubmit = this.handleParentSettingsSubmit.bind(this);
		this.handleTabSelect = this.handleTabSelect.bind(this);
		this.handleReferralSourceChange = this.handleReferralSourceChange.bind(this);
		this.handleSendMessage = this.handleSendMessage.bind(this);
		this.initializeReferralSourceType = false;

		this.state = {
			referralSourceId: '',
			notFoundError: false
		};
	}

	componentDidMount() {
		const { match, fetchParent } = this.props;
		const parentId = match.params.id;

		if (parentId) {
			const onErrorEvent = () => { this.setState({ notFoundError: true }); };
			const onSuccessEvent = () => { this.setState({ notFoundError: false }); };
			fetchParent(parentId, onErrorEvent, onSuccessEvent);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.parent && !this.initializeReferralSourceType) {
			this.initializeReferralSourceType = true;
			this.setState({ referralSourceId: nextProps.parent.referralSourceId });
		}
	}

	handleTabSelect(key) {
		const parentId = this.props.parent.id;
		this.props.history.replace(`/parents/${parentId}/${key}`);
	}

	handleParentSettingsSubmit(values) {
		const { parent, createParent, updateParent, history } = this.props;

		if (parent) {
			updateParent(parent.id, values);
		} else {
			createParent(values, history);
		}
	}

	handleReferralSourceChange(event, referralSourceId) {
		this.setState({ referralSourceId });
	}

	handleSendMessage(values, onSuccess) {
		const { parent, sendMessage } = this.props;

		if (parent) {
			sendMessage({ ...values, parentIds: [parent.id] }, () => {
				onSuccess();
				if (this.props.match.params.tab === 'communications' ) {
					window.location.reload();
				}
			});
		}
	}

	render() {
		const { parent, isReadonly, titleTypes, referralSourceTypes, match, canImpersonate, canSendMessage, currentUser, frontOfficeUrl,
			childFormsDashboard, enableSelfAssessments, allowConsultations, allowConsultationForms, allowWorkshops,
			showTimetableInUserTimeZone, viewSentEmails, enableMakeUps, t } = this.props;
		const selectedTab = match.params.tab || 'parent';

		const loginAsParentUrl = parent && `${frontOfficeUrl}/impersonate?i=${encodeURIComponent(parent.username)}&o=${encodeURIComponent(currentUser.username)}`;

		return (
			<div>
				<BackButton style={{ marginBottom: '10px' }}>{t('Common_BackToList')}</BackButton>
				{parent && <ButtonToolbar className='pull-right'>
					{canSendMessage && <SendMessageButton onSendMessage={this.handleSendMessage} to={[{ name: parent.fullName, email: parent.email }]}
						block={PARENT_SEND_MESSAGE_REQUEST} unblock={[PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE]} />}
					{canImpersonate && <a href={loginAsParentUrl} target='blank' className='btn btn-orange'><FontAwesomeIcon icon={faRightToBracket} /> {t('Parent_LoginAsUser')}</a>}
				</ButtonToolbar>}
				<Tabs defaultActiveKey={selectedTab} id='parent-parent-tabs' onSelect={this.handleTabSelect}>
					<Tab eventKey='parent' title={t('Parent_Tab_Parent')}>
						<ParentSettingsForm isReadonly={isReadonly} onSubmit={this.handleParentSettingsSubmit} initialValues={parent}
							titleTypes={titleTypes}
							referralSourceTypes={referralSourceTypes}
							referralSourceId={this.state.referralSourceId}
							onReferralSourceChange={this.handleReferralSourceChange}
							notFoundError={this.state.notFoundError}
							showTimetableInUserTimeZone={showTimetableInUserTimeZone}
						/>
					</Tab>
					{parent && <Tab eventKey='children' title={t('Parent_Tab_Children')}>
						<Switch>
							<Route path={`/parents/${parent.id}/children`} exact render={props => <ChildrenList parentId={parent.id} />} />
							<Route path={`/parents/${parent.id}/children/new`} render={props => <ChildDetails parentId={parent.id} {...props} />} />
							<Route path={`/parents/${parent.id}/children/:childId/:tab?`} render={props => <ChildDetails parentId={parent.id} {...props} />} />
						</Switch>
					</Tab>}
					{parent && <Tab eventKey='paymentHistory' title={t('Parent_Tab_LessonPayments')}>
						<Switch>
							<Route path={`/parents/${parent.id}/paymentHistory`} exact render={props => <PaymentHistory parent={parent} />} />
						</Switch>
					</Tab>}
					{parent && <Tab eventKey='enrolments' title={t('Parent_Tab_Enrolments')}>
						<Switch>
							<Route path={`/parents/${parent.id}/enrolments`} exact render={props => <Enrolments parent={parent} />} />
						</Switch>
					</Tab>}
					{parent && enableMakeUps && <Tab eventKey='makeupSummary' title={t('Parent_Tab_MakeupSummary')}>
						<Switch>
							<Route path={`/parents/${parent.id}/makeupSummary`} exact render={props => <ParentMakeupSummary parent={parent} />} />
						</Switch>
					</Tab>}
					{parent && allowWorkshops && <Tab eventKey='workshops' title={t('Parent_Tab_Workshops')}>
						<Switch>
							<Route path={`/parents/${parent.id}/workshops`} exact render={props => <WorkshopPayments parentId={parent.id} />} />
						</Switch>
					</Tab>}
					{parent && allowConsultations && <Tab eventKey='individualConsultations' title={t('Parent_Tab_IndividualConsultations')}>
						<Switch>
							<Route path={`/parents/${parent.id}/individualConsultations`} exact render={props => <IndividualConsultations parentId={parent.id} />} />
						</Switch>
					</Tab>}
					{parent && allowConsultationForms && <Tab eventKey='forms' title={t('Parent_Tab_Forms')}>
						<Switch>
							<Route path={`/parents/${parent.id}/forms`} exact render={props => <IndividualConsultationForms parent={parent} childDashboardComponentName={childFormsDashboard} />} />
						</Switch>
					</Tab>}
					{parent && <Tab eventKey='parentDocuments' title={t('Parent_Tab_Documents')}>
						<Switch>
							<Route path={`/parents/${parent.id}/parentDocuments`} exact render={props => <ParentDocumentsList parentId={parent.id} />} />
							<Route path={`/parents/${parent.id}/parentDocuments/new`} render={props => <ParentDocumentDetails parentId={parent.id} {...props} />} />
							<Route path={`/parents/${parent.id}/parentDocuments/:parentDocumentId`} render={props => <ParentDocumentDetails parentId={parent.id} {...props} />} />
						</Switch>
					</Tab>}
					{parent && enableSelfAssessments && <Tab eventKey='selfAssessments' title={t('Parent_Tab_SelfAssessments')}>
						<Switch>
							<Route path={`/parents/${parent.id}/selfAssessments`} exact render={props => <SelfAssessments parent={parent} />} />
						</Switch>
					</Tab>}
					{parent && viewSentEmails && <Tab eventKey='communications' title={t('Parent_Tab_Communications')}>
						<Switch>
							<Route path={`/parents/${parent.id}/communications`} exact
								render={props => <ParentCommunications parentId={parent.id}  />} />
						</Switch>
					</Tab>}
				</Tabs>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const parentId = ownProps.match.params.id;
	const selectedTab = ownProps.match.params.tab;

	const {
		entities: { parents },
		lookups: { titleTypes, referralSourceTypes },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	return {
		parent: parents[parentId],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Parents'),
		titleTypes: titleTypes,
		referralSourceTypes: referralSourceTypes,
		canImpersonate: authUtils.hasPermission(currentUser, 'ImpersonateFrontOfficeUsers'),
		canSendMessage: franchisor.enableAdHocMessages && authUtils.hasPermission(currentUser, 'SendMessage'),
		frontOfficeUrl: franchisor.frontOfficeUrl,
		childFormsDashboard: franchisor.customUIComponents && franchisor.customUIComponents.childFormsDashboard,
		enableSelfAssessments: franchisor.enableSelfAssessments && authUtils.hasPermission(currentUser, 'SelfAssessments'),
		currentUser,
		allowWorkshops: franchisor.offerWorkshops && authUtils.hasPermission(currentUser, 'WorkshopPayments'),
		allowConsultations: franchisor.offerIndividualConsultations && authUtils.hasPermission(currentUser, 'IndividualConsultations'),
		allowConsultationForms: franchisor.offerIndividualConsultations && authUtils.hasPermission(currentUser, 'IndividualConsultationDocuments'),
		showTimetableInUserTimeZone: franchisor && franchisor.showTimetableInUserTimeZone,
		viewSentEmails: authUtils.hasPermission(currentUser, 'SentEmails'),
		enableMakeUps: franchisor.enableMakeUps
	};
};

export default connect(mapStateToProps, {
	fetchParent,
	createParent,
	updateParent,
	sendMessage
})(withTranslation()(Details));